import { NO_ERRORS_SCHEMA } from '@angular/core';
import { FormatPhonePipe } from '../../../_helpers/_pipes/format-phone.pipe';
import { MapfreIconComponent } from '../../individual-components/mapfre-icon/mapfre-icon.component';
import { MapfreCustomTooltipComponent } from '../../wrapper-components/custom-tooltip/mapfre-custom-tooltip.component';
import { TooltipComponent } from '../tooltip/tooltip.component';
import { MapfreLabelComponent } from '../../individual-components/inputs/mapfre-label/mapfre-label.component';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone
} from "@angular/core";
import { FormGroup , FormsModule , ReactiveFormsModule } from '@angular/forms';
import { AlertService } from "../../../_services/alert.service";
import { FormBase } from "../../../_models/form-base";
import { RegExHelper } from "../../../_helpers/regex-helper";
import { GetGooglePlaceService } from "../../../_services/get-google-place.service";
import { ValidateAddressService } from "./../../../_services/validate-address.service";
import { ErrorMessageService } from "../../../_services/error-message.service";
import { AcmicService } from "../../../_services/acmic.service";


declare let google: any;


export interface UnformattedDate {
  day: string;
  month: string;
  year: string;
}

@Component({
  standalone: true,
  schemas: [NO_ERRORS_SCHEMA],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule, MdbFormsModule, MapfreLabelComponent, TooltipComponent, MapfreCustomTooltipComponent, MapfreIconComponent, FormatPhonePipe],
  selector: "mapfre-validation",
  templateUrl: "./mapfre-input-with-validation.component.html"
})
export class MapfreIputWithValidationComponent
  implements OnInit, AfterViewInit {
  @Input() input: FormBase<any>;
  @Input() form: FormGroup;
  @Input() additionalClasses: string;
  @Input() changeAddressError = false;
  @Input() maximumLength = 999999999;
  @Input() phoneNumber: string;
  @Input() error: boolean;
  @Input() policyStateCode: string;
  @Input() enableActiveStyle = false;
  addressErrorForAcmic = false;
  errorMessage: string;
  showError: boolean;
  showWarnIcon: boolean;
  inputKey: string;
  emailShowError = false;
  capsLock = false;
  notOnPageLoad = false;
  showPassword = false;
  showPasswordIcon = false;
  validInput = true;
  validMessageShow = false;
  message: any;
  blurInput: boolean;
  passwordMustNotErrorMsg : string;
  tooltipPos = (window.innerWidth < 768) ? 'left' : 'right';
  @ViewChild('password') password! : ElementRef;
  @Input() firstName: string;
  @Input() lastName: string;
  @Input() middleName: string;
  @Input ()
  set errorMsg(value: string){
    this.passwordMustNotErrorMsg = value;
    if(value){
      if(this.password) {
        const scrollToProfilePwdTitle = document.querySelector('#profilePwdTitle');
        setTimeout(() => {
          scrollToProfilePwdTitle.scrollIntoView();
        });
      }
    }
  }
  firstNameError = false;
  middleNameError = false;
  dobFormatError: boolean;
  lastNameError = false;
  nameError = false;
  showRequiredError = false;
  @Output() passwordValidationCheck: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  streetName: any = "";
  city: any = "";
  state: any = "";
  zipcode: any = "";
  customerNameValues: any = "";
  showInvalidZipcodeMsg = false;
  isPswdThirdRuleValid = false;
  isAddressTyped = false;
  isAcmic = false;
  isTooltipVisible = false;
  isFocused = false

  readonly MONTH_GROUP = 1;
    readonly DAY_GROUP = 2;
    readonly YEAR_GROUP = 3;
    readonly STRICT_DOB_PATTERN = /^(\d{2})(\d{2})(\d{4})$/;
    readonly PARTIAL_DOB_PATTERN = /(\d{1,2})?(\d{1,2})?(\d{1,4})?/;

  constructor(
    private alertService: AlertService,
    private regExHelper: RegExHelper,
    private ngZone: NgZone,
    private getGooglePlaceService: GetGooglePlaceService,
    private validateAddressService: ValidateAddressService,
    private errorMessageService: ErrorMessageService,
    private acmicService: AcmicService
  ) {
    this.dobFormatError = false;
    this.isAcmic = this.acmicService.isACMIC();
  }
  @ViewChild("autoCompleteAddress") placesRef: ElementRef;
  @ViewChild("zipcodeRef") zipcodeRef: ElementRef;
  @ViewChild("password") passwordValue: ElementRef;
  @Output() inputValidationCheck: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() commercialInputValidationCheck: EventEmitter<boolean> = new EventEmitter<
    boolean
  >();
  @Output() addressinputValidationCheck: EventEmitter<
    boolean
  > = new EventEmitter<boolean>();

  @HostListener("window:keydown", ["$event"])
  OnKeyDownGlobal(event) {
    this.checkCapsLock(event);
  }

  @HostListener("window:keyup", ["$event"])
  OnKeyUpGlobal(event) {
    this.checkCapsLock(event);
  }

  @HostListener('window:resize')
    onResize() {
      this.tooltipPos = (window.innerWidth < 768) ? 'left' : 'right';
    }
  /* date validator-start */
  
  modifyOrPadDateValues(strippedStr: string): string {
    const dobGroups = this.getUnformattedObject(strippedStr);

    if (dobGroups.month) {
        dobGroups.month = this.modifyOrPadValue(dobGroups.month, 12);
    }

    if (dobGroups.day) {
        dobGroups.day = this.modifyOrPadValue(dobGroups.day, 31);
    }

    return (dobGroups.month || '') + (dobGroups.day || '') + (dobGroups.year || '');
}

  getUnformattedObject(date: string, strict = false): UnformattedDate {
    date = this.removeUnimportantChars(date);

    let dobGroups;

    if (strict) {
        dobGroups = this.STRICT_DOB_PATTERN.exec(date);

        if (!dobGroups) {
            return null;
        }
    } else {
        dobGroups = this.PARTIAL_DOB_PATTERN.exec(date);
    }

    return {
        day: dobGroups[this.DAY_GROUP],
        month: dobGroups[this.MONTH_GROUP],
        year: dobGroups[this.YEAR_GROUP]
    };
  }

  modifyOrPadValue(str: string, max: number): string {
      if (str.charAt(0) !== '0' || str === '00') {
          let num = +str;
          if (isNaN(num) || num <= 0 || num > max) {
              num = 1;
          }
          str = num > +max.toString().charAt(0) && num.toString().length === 1 ? '0' + num : num.toString();
      }

      return str;
  }
  removeUnimportantChars(value: string) {
    
    return value.replace(/\D/g, '');
  }

  insertSpecialChars(strippedValue: string) {
    if (!strippedValue) {
        return strippedValue;
    }

    if (strippedValue.length <= 1) {
        strippedValue = strippedValue.replace(/^(\d{2})?/, '$1');
    } else if (strippedValue.length <= 3) {
        strippedValue = strippedValue.replace(/^(\d{2})(\d{0,2})?/, '$1/$2');
    } else {
        strippedValue = strippedValue.substring(0, 8);
        strippedValue = strippedValue.replace(/^(\d{2})(\d{2})(\d{0,4})?/, '$1/$2/$3');
    }

    return strippedValue;
  }

  checkForValidDateRegex(date, ref): boolean {
    const date_regex = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;
    if(this.input.key === "enrollDob") {
      const splitDate = date.split('-');
      const year = splitDate[0];
      const month = splitDate[1];
      const day = splitDate[2];
      date = `${month}/${day}/${year}`;
    }
    const isFuterDate = (new Date(date) > new Date());
    
    if (!(date_regex.test(date))) {
    return false;
    } else {
      if (isFuterDate) {
        this.showDateFormatError(ref);
      }
      return true;
    }
  }

  formateDateField(date, ref): void {
    if(this.input.key !== "enrollDob") {
      date = this.removeUnimportantChars(date);
      date = this.modifyOrPadDateValues(date);
      date = this.insertSpecialChars(date);
      ref.form.controls[ref.input.key].setValue(date);
    }
    if(this.checkForValidDateRegex(date, ref)) {
      this.validInput = true;
    }
  }

  /* date validator end */
  characterCount(string, char) {
    if (char.match(/^[.()[*+?$^+|]/)) {
      const re = new RegExp("\\" + char, "gi");
      return string.match(re).length;
    } else {
      const re = new RegExp(char, "gi");
      return string.match(re).length;
    }
  }

  OnBlur(ref): void {   
    this.isFocused = false  
    const inputValue = ref.form.controls[ref.input.key].value;
    if(this.input.key === "signUpFirst_name" || this.input.key === "signUpLast_name" ) {
      ref.form.controls[ref.input.key].setValue(inputValue.trim());
    }
    this.notOnPageLoad = true;       
    if (this.checkForBlankInputField(inputValue)) {
      if ((this.input.key === "signUpDob" || this.input.key === "enrollDob") && this.input["type"] == "dob") {
        if(!this.checkForValidDateRegex(inputValue, ref)) {
          this.showDateFormatError(ref);
        }
      } else {
        this.validInput = this.isValid;
        this.validMessageShow = true;
      }
    } else {
      if (!this.input.required) {
        this.validInput = true;
        this.validMessageShow = true;
      } else {
        this.validMessageShow = false;
        this.showRequiredError = true;
        this.validInput = false;
        if(ref.input.key === 'createAc_companyName') {
          this.commercialInputValidationCheck.emit(false);
        }
      }
    }

    this.input.showErrorMsg = this.validMessageShow;    
    this.showWarnIcon = this.input.showWarnIcon; 
  }

  OnFocus(ref): void {
    void ref;
    this.validInput = true;
    this.isFocused = true;

    if (this.placesRef != undefined && this.input.inputType == "address") {
        const autocomplete = new google.maps.places.Autocomplete(
          this.placesRef.nativeElement,
          {
            types: ["address"],
            componentRestrictions: { country: "us" }
          }
        );

        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            const place: any = autocomplete.getPlace();
            this.OnBlurStoreAddress(place.formatted_address);
            this.createAddressObject(place, this.placesRef.nativeElement.value);
            if (place.geometry === undefined || place.geometry === null) {
              return;
            }
          });
        });
    }
  }

  getAddressByZipcode(ref) {
    void ref;
    const currentZipcode = this.zipcodeRef.nativeElement.value;
    let city = "";
    let state = "";
    if (currentZipcode.length > 4) {
        const geoCoder = new google.maps.Geocoder();
        geoCoder.geocode(
          {
            componentRestrictions: {
              country: "us",
              postalCode: currentZipcode
            }
          },
          (result, status) => {
            if (status == google.maps.GeocoderStatus.OK) {
              if (result[0].address_components.length > 0) {
                result[0].address_components.forEach(element => {
                  if (element.types.includes("administrative_area_level_1")) {
                    state = element.short_name;
                  }
                  if (element.types.includes("locality")) {
                    city = element.long_name;
                  }
                  if (
                    city === "" &&
                    element.types.includes("administrative_area_level_2")
                  ) {
                    city = element.long_name;
                  }
                });
                if (
                  result[0].postcode_localities &&
                  result[0].postcode_localities.length > 0
                ) {
                  city = result[0].postcode_localities;
                }
                this.showInvalidZipcodeMsg = false;
                const addressObject = {
                  city: city,
                  state: state,
                  zipcode: currentZipcode
                };
                this.getGooglePlaceService.updateMailingPOBoxAdd(addressObject);
              }
            } else {
              this.getGooglePlaceService.updateMailingPOBoxAdd({
                city: "",
                state: "",
                zipcode: ""
              });
              this.showInvalidZipcodeMsg = true;
            }
          }
        );
    } else {
      this.getGooglePlaceService.updateMailingPOBoxAdd({
        city: "",
        state: "",
        zipcode: ""
      });
      this.showInvalidZipcodeMsg = true;
    }
  }

  selectAddress() {
    if (this.input.addressType == "residential") {
      const validateAddress = this.validateAddressService.validateAddress(
        this.placesRef.nativeElement.value,
        this.getGooglePlaceService,
        true,
        this.policyStateCode
      );

      if (validateAddress) {
        this.changeAddressError = false;
        this.addressinputValidationCheck.emit(true);
      } else {
        this.addressErrorForAcmic = this.acmicService.isACMIC();
        this.addressinputValidationCheck.emit(false);
        this.changeAddressError = true;
      }
    } else if (this.input.addressType == "mailing") {
      this.changeAddressError = false;
      this.addressinputValidationCheck.emit(true);
    }
  }

  onShowError() {
    if (this.showError) this.showError = !this.showError;
  }

  onkeyUpCheckAddress(): void {
    this.addressErrorForAcmic = this.acmicService.isACMIC();
    this.changeAddressError = true;
    this.addressinputValidationCheck.emit(false);
    this.isAddressTyped = true;
  }

  showDateFormatError(ref): void {
    this.validInput = false;
    this.dobFormatError = true;
    this.validMessageShow = true;
    ref.form.controls[ref.input.key].setErrors({ dobFormatError: true });
  }

  isItBackSpace(event): boolean {
    if(event && event.code === "Backspace") {
      return true;
    }
    return false;
  }
  OnKeyUp(ref, event?:KeyboardEvent): void {
    let customerLastName: any = "";
    this.firstNameError = false;
    this.middleNameError = false;
    this.nameError = false;
    this.lastNameError = false;
    this.showRequiredError= false;
    this.passwordMustNotErrorMsg = "";
    this.onShowError();
    const inputValue = ref.form.controls[ref.input.key].value;
    if ((this.input.key === "signUpDob" || this.input.key === "enrollDob") && this.input["type"] === "dob") {
      if (this.isItBackSpace(event)) {
        // to clear the backspace
        ref.form.controls[ref.input.key].setValue(inputValue);
        if(!this.checkForValidDateRegex(inputValue, ref)) {
          this.showDateFormatError(ref);
        }
      } else {
        this.formateDateField(inputValue, ref);
      }
    }
    // split the first name value in the event it carries the first and last name value (as with legacy policies).
    if (this.firstName != undefined) {
      this.customerNameValues = this.firstName
        .toLowerCase()
        .trim()
        .split(/\s+/);
    }
    if (this.lastName != undefined) {
      customerLastName = this.lastName
        .toLowerCase()
        .trim()
        .split(/\s+/);
    }
    this.showPasswordIcon = this.checkForBlankInputField(inputValue);
    if (this.input.inputType === 'password') {
      if (inputValue != undefined || inputValue != null) {

        
        if(this.firstName != undefined && inputValue.toLowerCase() === this.firstName.toLowerCase()) {
          this.firstNameError = true;
        } else if (this.lastName != undefined && inputValue.toLowerCase().includes(this.lastName.toLowerCase())) {
          this.lastNameError = true;
        } else if((this.firstName != undefined && inputValue.toLowerCase().includes(this.customerNameValues[0].toLowerCase()))) {
          this.firstNameError = true;
        } else if (this.firstName != undefined && this.customerNameValues.length > 1 && inputValue.toLowerCase().includes(this.customerNameValues[this.customerNameValues.length - 1].toLowerCase())) {
          this.lastNameError = true;
        } else if (this.middleName != undefined && (inputValue.toLowerCase() === this.firstName.toLowerCase() || (this.middleName.length > 3 && 
            inputValue.toLowerCase().includes(this.middleName.toLowerCase())))){
          this.middleNameError = true;
        } else if (customerLastName.length > 1) {
          customerLastName.forEach(name => {
            this.setNameValidationError(inputValue, name);
          });
          this.customerNameValues.forEach(name => {
            this.setNameValidationError(inputValue, name);
          });
        }

      }

      if (this.firstNameError || this.lastNameError || this.middleNameError || this.nameError) {
        this.passwordValidationCheck.emit(false);
      } else {
        this.passwordValidationCheck.emit(true);
      }
      if (this.input.key === "createPassword") {
        const passThirdRuleRegex = new RegExp(
          this.regExHelper.passwordRulesPattern["ruleThree"]
        );
        this.isPswdThirdRuleValid = passThirdRuleRegex.test(
          this.form.controls["createPassword"].value
        );
      }
    }
  }
  setNameValidationError(inputValue, name){
    if (inputValue.toLowerCase().includes(name)){
      this.nameError = true;
    }
  }
  passwordRuleErrorBasedOnFnameAndLname(inputValue, customerLastName) {
    if (
      this.firstName &&
      inputValue.toLowerCase() === this.firstName.toLowerCase()
    ) {
      this.firstNameError = true;
    } else if (
      this.lastName &&
      inputValue.toLowerCase().includes(this.lastName.toLowerCase())
    ) {
      this.lastNameError = true;
    } else if (
      this.firstName &&
      inputValue
        .toLowerCase()
        .includes(this.customerNameValues[0].toLowerCase())
    ) {
      this.firstNameError = true;
    } else if (
      this.firstName &&
      this.customerNameValues.length > 1 &&
      inputValue
        .toLowerCase()
        .includes(
          this.customerNameValues[
            this.customerNameValues.length - 1
          ].toLowerCase()
        )
    ) {
      this.lastNameError = true;
    } else if (customerLastName.length > 1) {
      this.setNameError(customerLastName, inputValue);
    }
  }
  setNameError(customerLastName, inputValue) {
    customerLastName.forEach(name => {
      this.setNameValidationError(inputValue, name);
    });
    this.customerNameValues.forEach(name => {
      this.setNameValidationError(inputValue, name);
    });
  }
  get isValid() {
    const formValid = this.form.controls[this.input.key];
    if (formValid.valid && (formValid.dirty || formValid.touched)) {
      this.inputValidationCheck.emit(true);
      if(this.input.key === 'createAc_companyName') {
        this.commercialInputValidationCheck.emit(true);
      }
      this.input.showErrorMsg = false; 
      return true;
    } else {
      this.inputValidationCheck.emit(false);
      if(this.input.key === 'createAc_companyName' && (formValid.dirty || formValid.touched)) {
        this.commercialInputValidationCheck.emit(false);
      }
      
      if((this.input.key === "bankAccountNumber" || this.input.key === "confirmBankAccountNumber") 
      ) {
        const bankAccNumber = this.form.controls['bankAccountNumber'];
        const bankConfirmAccNumber = this.form.controls['confirmBankAccountNumber'];
        if(bankAccNumber.value === bankConfirmAccNumber.value) {
          this.validInput = true;
          this.form.controls['bankAccountNumber'].setErrors(null);
          this.form.controls['confirmBankAccountNumber'].setErrors(null);          
        } else if((bankAccNumber && bankAccNumber.errors && bankAccNumber.errors.invalidBankAccNumber) || 
        (bankConfirmAccNumber && bankConfirmAccNumber.errors && bankConfirmAccNumber.errors.invalidConfirmBankAccNumber)) {
          this.validInput = false;          
        }
      }
      if(this.input.inputType === 'otp') {
        const validateOtp = this.form.controls['validateOtp'];
        if (validateOtp &&
          validateOtp.errors &&
          validateOtp.errors.invalidOtp) {
          this.input.validationMessageError = "Invalid or expired code";
        } else {
          this.input.validationMessageError = "Please enter security code";
        }
      }

      if(this.input.inputType === 'bank_account_number') {
        const enrollEftAcc = this.form.controls[this.input.key];
        if(enrollEftAcc && enrollEftAcc.errors && enrollEftAcc.errors.invalidAccount) {
          this.input.validationMessageError = "Please enter new bank account number and validate routing number";
          this.validMessageShow = true;
        }
      }

      if (this.input.inputType === 'email') {
        const validateEmail = this.form.controls['createAc_email'];
        if (validateEmail && validateEmail.errors && validateEmail.errors.invalidEmail && this.acmicService.isACMIC()) {
          this.input.validationMessageError = "Enter a different email";
        } else {
          this.input.validationMessageError = "Enter a valid email";
        }
      }
      if (this.input.key === 'noPhoneEmail_zipcode')  {
        const validateZip = this.form.controls['noPhoneEmail_zipcode'];
        if (validateZip && validateZip.errors && validateZip.errors.invalidZipCode) {
          this.input.validationMessageError = "ZIP code doesn't match our records";
          this.validMessageShow = true;
        } else {
          this.input.validationMessageError = "Enter a valid ZIP code";
        }
      }
      this.input.showErrorMsg = this.validMessageShow;
      return false;
    }
  }

  OnBlurStoreAddress(selectedAddress?) {
    if (selectedAddress || !this.isAddressTyped) {
      this.validateAddressService.updateAddress(
        this.placesRef.nativeElement.value
      );
      this.errorMessageService.updateErrorMessage({
        message: "",
        error: false,
        key: ""
      });
      this.changeAddressError = false;
      this.addressinputValidationCheck.emit(true);
      this.isAddressTyped = false;
    } else {
      this.changeAddressError = true;
      this.addressErrorForAcmic = this.acmicService.isACMIC();
      this.addressinputValidationCheck.emit(false);
    }
  }

  alertServiceMessage(): void {
    this.alertService.getMessage().subscribe(message => {
      if (message == null) return false;
      this.message = message;
    });
  }

  checkCapsLock(event: KeyboardEvent): void {
    if (event.code === "CapsLock") {
      if (event.getModifierState && event.getModifierState("CapsLock")) {
        this.capsLock = true;
      } else {
        this.capsLock = false;
      }
    }
  }

  checkForBlankInputField(value: string): boolean {
    if (value != null && value.length >= 1) {
      return true;
    }
    return false;
  }

  checkForRegularInput(input): boolean {
    if (
      input.inputType != "email" &&
      input.inputType != "password" &&
      input.inputType != "bank" &&
      input.inputType != "bank_account_number" &&
      input.inputType != "phone" &&
      input.inputType != "address" &&
      input.inputType != "money" &&
      input.inputType != "textarea" &&
      input.inputType != "zipcode" &&
      input.inputType != "poBoxNumber" &&
      input.inputType != "accountType"
    ) {
      return true;
    } else {
      return false;
    }
  }

  passwordRules(reg: string): boolean {
    if (
      this.form.controls["createPassword"].value != null ||
      this.form.controls["createPassword"].value != undefined
    ) {
      return this.regExHelper.regExPasswordStrength(
        reg,
        this.form.controls["createPassword"].value
      );
    }
  }

  showPasswordFunction(event): void {
    this.showPassword = event;
  }

  createAddressObject(addressInput, addressString) {

    const formattedAddress = addressString.split(",");

    const streetAddressAbv = addressInput["formatted_address"]
      .split(",")[0]
      .trim();

    const streetName = formattedAddress[0].trim();

    const city =
      formattedAddress.length === 5
        ? formattedAddress[2].trim()
        : formattedAddress[1].trim();

    const placeFilter = addressInput["address_components"].filter(address => {
      return (
        address.types[0] === "administrative_area_level_1" ||
        address.types[0] === "postal_code"
      );
    });

    const addressObj = placeFilter.reduce((addObj, item) => {
      addObj[item.types[0]] = item.short_name;
      return addObj;
    }, {});

    const resultObj = {
      streetName: `${streetName}`,
      city: `${city}`,
      state: `${addressObj.administrative_area_level_1.toUpperCase()}`,
      zipCode: {
        code: `${addressObj.postal_code}`
      }
    };

    const resultObjAbv = {
      streetName: `${streetAddressAbv}`,
      city: `${city}`,
      state: `${addressObj.administrative_area_level_1.toUpperCase()}`,
      zipCode: {
        code: `${addressObj.postal_code}`
      }
    };

    this.getGooglePlaceService.updateAddress(resultObj);
    this.getGooglePlaceService.updateAddressAbv(resultObjAbv);

    this.selectAddress();
  }

  onTolltipHover() {
    this.isTooltipVisible = true;
  }

  showToolTip(event) {
    this.isTooltipVisible = event;
  }

  ngOnInit(): void {
    this.blurInput = false;
    this.alertServiceMessage();
    this.errorMessageService.$errorMessage.subscribe(response => {
      this.errorMessage = response.message;
      this.showError = response.error;
      this.inputKey = response.key;
    });
    this.getGooglePlaceService.$mailingPOBoxAddress.subscribe(addressFields => {
      if (addressFields) {
        this.streetName = addressFields.streetName;
        this.city = addressFields.city;
        this.state = addressFields.state;
        this.zipcode = addressFields.zipcode;
      }
    });
  }

  ngAfterViewInit() {
    if (
      this.form.contains("changePassword") ||
      this.form.contains("createPassword")
    ) {
      if (this.passwordValue != undefined) {
        // this.passwordValue.nativeElement.focus();
      }
    }
  }
}
